// src/components/common/Modal.js
import { useEffect } from 'react';

const Modal = ({
    show,
    isOpen, // Backward compatibility with eModal API
    onClose,
    title,
    children,
    size = 'medium',
    maxWidth,          // optional explicit px/rem width override
    bodyOverflow       // optional: 'visible' lets absolute dropdowns escape the body
}) => {
    // Support both 'show' and 'isOpen' props for backward compatibility
    const isModalOpen = show || isOpen;

    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isModalOpen) {
                onClose();
            }
        };

        if (isModalOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isModalOpen, onClose]);

    // Handle backdrop click
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isModalOpen) return null;

    // Map size prop to modal class
    const getSizeClass = () => {
        switch (size) {
            case 'small':
                return 'modal-sm';
            case 'large':
                return 'modal-lg';
            case 'extra-large':
                return 'modal-xl';
            case 'full':
                return 'modal-full';
            default:
                return 'modal-md';
        }
    };

    return (
        <div className="modal-overlay" onClick={handleBackdropClick}>
            <div
                className={`modal-container ${getSizeClass()}`}
                style={maxWidth ? { maxWidth } : undefined}
            >
                <div className="modal-header modal-header-primary">
                    <h3 className="modal-title">{title}</h3>
                    <button
                        className="close-btn"
                        onClick={onClose}
                        type="button"
                        aria-label="Close modal"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div
                    className="modal-body"
                    style={bodyOverflow ? { overflow: bodyOverflow } : undefined}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
